import { FormBase } from 'core/components';

export default class ExportInventoryByDateForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'sellerId',
					label: 'Seller',
				},
				{
					name: 'date',
					label: 'Date',
				},
			],
		};
	}
}
